
import { TableHeadDataProps } from '../../components/Table/TableHead';

export const RTMPlanTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: '' },
  { id: 1, title: 'Plan Name', value: 'name' },
  { id: 2, title: 'Template', value: 'transmissionTemplateId?.name' },
  { id: 3, title: 'Text Message', value: 'type' },
  { id: 4, title: 'Frequency', value: 'frequency' }, // was missing!
  { id: 5, title: 'Time-Zone', value: 'timeZone' },
  { id: 6, title: 'Time', value: 'time' },
  { id: 7, title: 'Biling Cycle', value: 'billingCycle' },
  { id: 8, title: 'Continuous', value: 'isContinueuseBilling' },
  { id: 9, title: 'Intake Form', value: 'intakeFormId?.name' },
  { id: 10, title: 'Status', value: 'isActive' },
  { id: 11, title: 'Actions' },
    { id: 12, title: '' },
];
